import * as AddressActionTypes from '../actionTypes/AddressActionTypes';

export const updateAddresses = (params) => ({
    type: AddressActionTypes.UPDATE_ADDRESSES,
    payload: params,
});

export const postAddresses = (params) => ({
    type: AddressActionTypes.POST_ADDRESSES,
    payload: params,
});

export const deleteAddresses = (addressId, userAction, params = {}) => ({
    type: AddressActionTypes.DELETE_ADDRESSES,
    payload: {
        addressId,
        params,
    },
    userAction,
});

export const deleteAddressCreate = (payload) => ({
    type: AddressActionTypes.DELETE_ADDRESSES_CREATE,
    payload,
});

export const deleteAddressUpdate = (addressId, params) => ({
    type: AddressActionTypes.DELETE_ADDRESSES_UPDATE,
    payload: {
        addressId,
        params,
    },
});

export const cleanRequest = () => ({
    type: AddressActionTypes.CLEAN_REQUEST_ADDRESSES,
});

export const hideAddress = () => ({
    type: AddressActionTypes.HIDE_ADDRESS,
});

export const setDefaultAddressAction = (id) => ({
    type: AddressActionTypes.SET_DEFAULT_ADDRESS,
    payload: { id, requestBody: [{ op: 'replace', path: '/expressCheckout', value: 'true' }] },
});
